@let view = data();

<ui-headlines [data]="view.headlines"></ui-headlines>
<ul>
  @for (item of view.items; track item) {
    <li>
      <a [href]="item.path">
        <span class="name">{{ item.name }}</span>
        <ui-icon [faName]="fileIcons[item.type] ?? genericFileIcon" faStyle="light"></ui-icon>
        <span class="size">{{ item.size }}</span>
        <ui-icon faName="down-to-bracket" faStyle="light"></ui-icon>
      </a>
    </li>
  }
</ul>
